export default __webpack_public_path__ + "static/media/coracao.7c36b307.svg";